var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"subscription"},[_c('div',{staticClass:"container mx-auto"},[_c('echart',{staticClass:"w-full",attrs:{"options":_vm.graphOptions}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }